import React from "react";

export const PauseFill: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <clipPath id="master_svg0_1041_165739/1087_83061/1087_89884">
        <rect x="0" y="0" width="24" height="24" rx="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#master_svg0_1041_165739/1087_83061/1087_89884)">
      <g>
        <path
          d="M6.750000476837158,6.225000381469727L6.750000476837158,17.775000381469727C6.750000476837158,18.603400381469726,7.421573476837159,19.275000381469727,8.250000476837158,19.275000381469727C9.078430476837159,19.275000381469727,9.750000476837158,18.603400381469726,9.750000476837158,17.775000381469727L9.750000476837158,6.225000381469727C9.750000476837158,5.396573381469727,9.078430476837159,4.725000381469727,8.250000476837158,4.725000381469727C7.421573476837159,4.725000381469727,6.750000476837158,5.396573381469727,6.750000476837158,6.225000381469727ZM14.250000476837158,6.225000381469727L14.250000476837158,17.775000381469727C14.250000476837158,18.603400381469726,14.921570476837157,19.275000381469727,15.750000476837158,19.275000381469727C16.57843047683716,19.275000381469727,17.250000476837158,18.603400381469726,17.250000476837158,17.775000381469727L17.250000476837158,6.225000381469727C17.250000476837158,5.396573381469727,16.57843047683716,4.725000381469727,15.750000476837158,4.725000381469727C14.921570476837157,4.725000381469727,14.250000476837158,5.396573381469727,14.250000476837158,6.225000381469727Z"
          fillRule="evenodd"
          fill="currentColor"
          fillOpacity="0.8799999952316284"
        />
      </g>
    </g>
  </svg>
);
